module.exports = __webpack_public_path__ + "media/images/massage/malika-b9e6b440d154193579e5630dd78a88f7.jpg";